export const queryKeys = {
  matches: ['matches'],
    matchesByRegion: (region, leagueLevel) => ['matches', region, leagueLevel],
    allMatches: (leagueLevel) => ['matches', 'all', leagueLevel],
    sliderMatches: (leagueLevel) => ['matches', 'slider', leagueLevel],
  standings: ['standings'],
  standingsByRegion: (region, leagueLevel) => ['standings', region, leagueLevel],
}
